import { type BuildCloudImageUrlParams, buildCloudImageUrl } from '@front/common/src/utils/image';

export const fetchFromCloudImage = ({ height, token, url, width }: BuildCloudImageUrlParams) => ({
  src: buildCloudImageUrl({ height, token, url, width }),
  double: buildCloudImageUrl({ height: 2 * height, token, url, width: 2 * width }),
  triple: buildCloudImageUrl({ height: 3 * height, token, url, width: 3 * width }),
});

export const getSrcSet = (...sizes: (string | undefined)[]) =>
  sizes.reduce(
    (srcSet: string, size, i) => (size ? srcSet.concat(`${srcSet && i > 0 ? ', ' : ''}${size} ${i + 1}x`) : srcSet),
    '',
  );
